import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  authToken: null,
  userId: null,
  profile_picture: null,
  name: null,
  stripeId: null,
  email: null,
  lang: "en",
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setLang: (state, action) => {
      state.lang = action.payload.lang;
    },
    setAuth: (state, action) => {
      state.authToken = action.payload.authToken;
      state.userId = action.payload.userId;
      state.profile_picture = action.payload.profile_picture;
      state.name = action.payload.name;
      state.stripeId = action.payload.stripeId;
      state.email = action.payload.email;
    },
    updateStripeId: (state, action) => {
      state.stripeId = action.payload.stripeId;
    },
    updateProfilePicture: (state, action) => {
      state.profile_picture = action.payload.profile_picture;
    },
    updateName: (state, action) => {
      state.name = action.payload.name;
    },
    logout: (state) => {
      state.authToken = null;
      state.userId = null;
      state.profile_picture = null;
      state.name = null;
      state.stripeId = null;
      state.email = null;
    },
  },
});

export const {
  setLang,
  setAuth,
  logout,
  updateProfilePicture,
  updateStripeId,
  updateName,
} = authSlice.actions;

export default authSlice.reducer;
